/* eslint-disable no-param-reassign */
import produce from 'immer';
import types from './types';

const INITIAL_FILTER = {
  period: 7,
};

const INITIAL_STATE = {
  filter: INITIAL_FILTER,
  dashboardData: null,
};

export default function reducer(baseState = INITIAL_STATE, action) {
  return produce(baseState, (draftState) => {
    switch (action.type) {
      case types.DASHBOARD_SET_STATE: {
        Object.keys(action.payload.state).forEach((objectKey) => {
          draftState[objectKey] = action.payload.state[objectKey];
        });
        break;
      }
      default:
    }
  });
}
